import { useQuery } from '@tanstack/react-query'
import { Flex, Radio, Space } from 'antd'
import dayjs from 'dayjs'
import { useFormik } from 'formik'
import CustomDataTable from 'general/components/CustomDataTable'
import BaseTextField from 'general/components/Forms/BaseTextField'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import Global from 'general/utils/Global'
import Utils, {
  findObjectInArray,
  getYearsFromDates,
} from 'general/utils/Utils'
import ValidationSchema from 'general/utils/ValidationSchema'
import { useAppSelector } from 'hooks/useRedux'
import useSearchDebounce from 'hooks/useSearchDebounce'
import useToken from 'hooks/useToken'
import PropTypes from 'prop-types'
import { useEffect, useMemo, useRef, useState } from 'react'
import DraggableModal from '../DragableModal/DraggableModal'
import { queryKeys } from './queries'
import FilterPopover from 'general/components/CustomPopover/FilterPopover'
import SelectOptions from 'general/constants/SelectOptions'
import useFilter from 'hooks/useFilter'
import useGetSerials from 'hooks/Queries/useGetSerials'
import _, { repeat } from 'lodash'
import TableAction from 'general/components/GroupButton/TableAction'
import { IconAction } from 'general/components/GroupButton/styles'
import { SpanNotYetReleasedTd } from 'features/TaxDeductionDocuments/styled'

FindRegistrationModal.propTypes = {
  selectableRows: PropTypes.bool,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  onExistDone: PropTypes.func,
  title: PropTypes.string,
  showTab: PropTypes.bool,
  textButtonTab1: PropTypes.string,
  textButtonTab2: PropTypes.string,
  checkBoxShow: PropTypes.bool,
  buttonAgreeOnlick: PropTypes.func,
  buttonAgreeTab2Onlick: PropTypes.func,
  onRowClicked: PropTypes.func,
  buttonAgreeVisibility: PropTypes.bool,
  defaultTab: PropTypes.number,
}

FindRegistrationModal.defaultProps = {
  selectableRows: false,
  show: false,
  onClose: null,
  showTab: true,
  onExistDone: null,
  textButtonTab1: 'Hóa đơn',
  textButtonTab2: 'Hóa đơn trên hệ thống khác',
  checkBoxShow: true,
  buttonAgreeVisibility: false,
}

function FindRegistrationModal(props) {
  const {
    show,
    onHide,
    title,
    onRowClicked,
    selectableRows,
    buttonAgreeVisibility,
    defaultTab,
    isInvoice = true,
    createDateObject,
    value,
  } = props
  const { token } = useToken()
  const { debouncedSearch, setSearch } = useSearchDebounce('')
  const modalRef = useRef(null)
  const modalRefDetails = useRef(null)
  const modalRequest = useRef(null)
  const [currentTab, setCurrentTab] = useState(0)
  const [clearSelected, setClearSelected] = useState(false)
  const [showDetailLog, setShowDetailLog] = useState({ show: false })
  const [showDetailRequest, setShowDetailRequest] = useState({ show: false })
  const [filter, setFilter] = useFilter('gFilterHistoryErrAnnouce')
  const [dateSerial, setDateSerial] = useState([])
  const [typeView, setTypeView] = useState(2)
  const { data: serials } = useGetSerials(undefined, dateSerial)

  const formik = useFormik({
    initialValues: {
      no: '',
      serial: '',
      taxAuthorityCode: '',
      date: dayjs().utc().format('L'),
    },
    validationSchema: ValidationSchema.findInvoice,
    enableReinitialize: false,
    validateOnChange: false,
  })

  const {
    data: dataSource,
    isLoading: gettingListData,
    refetch,
  } = useQuery({
    ...queryKeys.lists({ companyId: value?.companyId }),
    enabled: false,
  })

  useEffect(() => {
    if (show) {
      refetch()
    }
  }, [show, refetch])

  useEffect(() => {
    console.log('value', value)
  }, [value])

  useEffect(() => {
    if (show) {
      setClearSelected((prev) => !prev)
      // setFilters((prev) => ({
      //   ...prev,
      //   ...Global.gFiltersInvoiceList_findmodal,
      //   q: debouncedSearch,
      //   ...filter,
      // }))
    }
  }, [debouncedSearch, show, filter])

  const allColumns = [
    {
      name: 'STT',
      width: '80px',
      center: true,
      cell: (row, index) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {(filter?.page - 1) * filter?.limit + (index + 1)}
          </p>
        )
      },
    },
    {
      name: 'Đối tượng',
      width: '110px',
      center: true,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row?.typeKey}
          </p>
        )
      },
    },
    {
      name: 'Ngày tạo',
      width: '160px',
      center: true,
      cell: (row) => {
        const date = dayjs(row?.createDate)
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {date.isValid() ? date.format('YYYY-MM-DD HH:mm:ss.SSS') : ''}
          </p>
        )
      },
    },
    {
      name: 'IP',
      width: '140px',
      // width: '300px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row?.ip}
          </p>
        )
      },
    },
    {
      name: 'Người cập nhật',
      width: '200px',
      // width: '300px',
      cell: (row) => {
        const company = findObjectInArray(
          dataSource?.companys,
          'userId',
          row?.userId,
        )
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row?.userId == 0
              ? 'Hệ thống'
              : `${company?.companyName} (${company?.taxCode}) `}
          </p>
        )
      },
    },
    {
      name: 'API',
      width: '200px',
      // width: '300px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row?.pathAPI}
          </p>
        )
      },
    },
    {
      name: 'Nội dung',
      // width: '300px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row?.content}
          </p>
        )
      },
    },
    {
      name: 'Loại thông báo',
      width: '150px',
      // width: '300px',
      cell: (row) => {
        const constStatus = findObjectInArray(
          SelectOptions.listTypeLogSymtem,
          'value',
          row.categoryLogId,
        )
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            <SpanNotYetReleasedTd
              color={constStatus?.color}
              backGroundColor={constStatus?.backGroundColor}
            >
              {constStatus?.label}
            </SpanNotYetReleasedTd>
          </p>
        )
      },
    },
    {
      name: 'Hành động',
      center: true,
      width: '120px',
      style: {
        justifyContent: 'flex-end',
      },
      cell: (row) => (
        <Space size={'3px'} align="center">
          <TableAction
            titleActionText="Xem chi tiết"
            icon={<IconAction className="fa-regular fa-eye" />}
            onClick={() => {
              setShowDetailLog({ show: true, data: row })
            }}
          />
          <TableAction
            titleActionText="Xem chi tiết request"
            icon={<IconAction className="fa-regular fa-code-pull-request" />}
            onClick={() => {
              setShowDetailRequest({ show: true, data: row })
            }}
          />
        </Space>
      ),
    },
  ]

  const columns = allColumns.filter((column) => !column.hidden)

  const handleDoubleClickInvoice = (row) => {}

  // useEffect(() => {
  //   setDateSerial(getYearsFromDates(filters))
  // }, [])

  return (
    <>
      <DraggableModal
        applyText="Đóng"
        ref={modalRef}
        // handleApplyChanges={handleApplyChanges}
        title={title}
        hasApplyButton={buttonAgreeVisibility}
        isOpen={show}
        onOpenChange={() => onHide()}
        width={'90%'}
        styles={{
          header: {
            borderBottom: Utils.cn('1px solid', token.colorBorderSecondary),
            margin: 0,
          },
          body: {
            padding: 0,
          },
          footer: {
            borderTop: Utils.cn('1px solid', token.colorBorderSecondary),
          },
        }}
      >
        <div className="p-0">
          <>
            <div
              className="d-flex flex-column"
              style={{
                backgroundColor: '#f3f5f7',
                fontSize: '14px',
              }}
            ></div>
            <Flex gap={'5px'} className="p-3 w-100">
              <div style={{ width: '250px' }}>
                <CustomAntInput
                  type="search"
                  borderRadius="sm"
                  inputProps={{
                    defaultValue: debouncedSearch,
                    onChange: (e) => setSearch(e.target.value),
                  }}
                  // width={'25%'}
                />
              </div>
              {/* <div
                style={{
                  width: '100%',
                  maxWidth: '750px',
                  display: 'flex',
                }}
              >
                <FilterPopover
                  defaultValues={filterCriteria}
                  onApply={setFilter}
                  savedKey={'gFilterInvoiceErrAnnouce'}
                  customDate={1}
                  customDateArray={[
                    dayjs(createDateObject),
                    dayjs(createDateObject).add(7, 'day'),
                  ]}
                  // onchangeDate={onchangeDate}
                />
              </div> */}
            </Flex>
            <div className="m-3">
              <CustomDataTable
                wrapperClassName="max-h-600px"
                columns={columns}
                dataSource={dataSource?.rows}
                isLoading={gettingListData}
                scrollY="600px"
                isSelectable={selectableRows}
                pagination={{
                  currentPage: filter?.page,
                  rowsPerPage: filter?.limit,
                  total: dataSource?.total,
                  onChangePage: (page) => {
                    setFilter({
                      ...filter,
                      page,
                    })
                  },
                  onChangeRowsPerPage: (limit) => {
                    setFilter({
                      ...filter,
                      limit,
                      page: 1,
                    })
                  },
                }}
                selectedRows={{
                  clearSelectedRows: clearSelected,
                  handleSelectedRows: ({ selectedRows }) => {},
                }}
                isClickable
                handleDoubleClickRow={handleDoubleClickInvoice}
              />
            </div>
          </>
        </div>
      </DraggableModal>

      {/* 
      <DraggableModal
        applyText="Đóng"
        ref={modalRequest}
        title={<>Chi tiết Request</>}
        isOpen={showDetailRequest.show}
        onOpenChange={() => {
          setShowDetailRequest({ show: false })
        }}
        handleApplyChanges={() => {
          setShowDetailRequest({ show: false })
        }}
        width={'70%'}
        styles={{
          header: {
            borderBottom: Utils.cn('1px solid', token.colorBorderSecondary),
            margin: 0,
          },
          body: {
            padding: 0,
          },
          footer: {
            borderTop: Utils.cn('1px solid', token.colorBorderSecondary),
          },
        }}
      >
        <div className="p-0">
          <>
            <div
              className="d-flex flex-column"
              style={{
                backgroundColor: '#f3f5f7',
                fontSize: '14px',
              }}
            ></div>
            <div
              className="row"
              style={{ height: 700, overflow: 'auto', marginRight: 0 }}
            >
              <div
                className="col-sm-12"
                style={{
                  overflow: 'auto',
                  maxHeight: '700px',
                  borderRight: '1px solid #ccc',
                  paddingLeft: 50,
                }}
              >
                <pre
                  style={{
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    cursor: 'pointer',
                  }}
                  onDoubleClick={() => {
                    navigator.clipboard.writeText(
                      showDetailRequest?.data?.request,
                    )
                    ToastHelper.showSuccess('Sao chép thành công')
                  }}
                  title="DoubleClick để sao chép"
                >
                  {JSON.stringify(
                    JSON.parse(showDetailRequest?.data?.request || '{}'),
                    null,
                    2,
                  )}
                </pre>
              </div>
            </div>
          </>
        </div>
      </DraggableModal> */}
    </>
  )
}

export default FindRegistrationModal
